import { render, staticRenderFns } from "./ucusraporu.vue?vue&type=template&id=60f859dc&scoped=true"
import script from "./ucusraporu.vue?vue&type=script&lang=js"
export * from "./ucusraporu.vue?vue&type=script&lang=js"
import style0 from "./ucusraporu.vue?vue&type=style&index=0&id=60f859dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f859dc",
  null
  
)

export default component.exports